module.exports = __webpack_public_path__ + "static/media/email_24px.3bf62271.svg";